import React from "react"
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import FooterSmall from "../../components/footer-small"
import ProjectFilter from "../../components/project-filter"

import bg1 from '../../assets/images/portfolio/bg.png'

import { footerSocial } from '../../data'
import { portfolioServices} from '../../data/data'


export default function IndexPortfolio() {
  
  return (
    <>
    <Navbar/> 

    <section className="bg-half-170 d-table w-100 bg-light" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="container">
          <div className="row mt-5">
              <div className="col-12">
                  <div className="title-heading">
                      <h4 className="heading fw-bold">We Are Leaping.</h4>
                      <h4 className="heading fw-bold mb-0">Canada based art & design studio</h4>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="py-5">
      <div className="container">
          <div className="row align-items-center">
              <div className="col-lg-3 col-md-4 text-center text-md-start">
                  <h5 className="text-muted">Contact via E-mail</h5>
                  <Link to="tel:+152534-468-854" className="text-dark h6 phone">+152 534-468-854</Link>
              </div>
              
              <div className="col-lg-3 col-md-4 text-center text-md-start mt-4 mt-sm-0">
                  <h5 className="text-muted">Contact via Phone</h5>
                  <Link to="mailto:contact@example.com" className="text-dark h6 mail">contact@example.com</Link>
              </div>
              
              <div className="col-lg-6 col-md-4 text-center text-md-end mt-4 mt-sm-0">
                  <ul className="list-unstyled text-sm-end social-icon social mb-0">
                    {footerSocial.map((item,index)=>{
                      let Icon = item.icon
                      return(
                        <li className="list-inline-item m-x-2" key={index}><Link to={item.link} target="_blank" className="rounded"><Icon className="align-middle"/></Link></li>
                      )
                    })}
                  </ul>
              </div>
          </div>
      </div>
    </section>

    <section className="section border-top">
      <div className="container">
          <div className="row">
            {portfolioServices.map((item,index)=>{
              let Icon = item.icon
              return(
                <div className="col-lg-3 col-md-6 mt-4 mt-sm-0 pt-2 pt-sm-0" key={index}>
                    <div className="feature p-4 shadow rounded text-center">
                        <Icon className="border-icon"/>
                        <div className="content">
                            <h4 className="title mt-3">{item.title}</h4>
                            <p className="text-muted mt-2 mb-0">{item.desc}</p>
                        </div>
                    </div>
                </div>
              )
            })}
          </div>
      </div>

      <div className="container-fluid mt-100 mt-60">
         <ProjectFilter/>

      </div>

      <div className="container mt-100 mt-60">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title">
                      <h4 className="title mb-4">Let's talk about your portfolio</h4>
                      <p className="text-muted para-desc mx-auto">Start work with Leaping. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  
                      <div className="mt-4 pt-2">
                          <Link to="#" className="btn btn-primary">Get Started Now</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>
    <FooterSmall/>
    </>
  )
}
